import { render } from "./EditCompte.vue?vue&type=template&id=dc7e1968&ts=true"
import script from "./EditCompte.vue?vue&type=script&lang=ts"
export * from "./EditCompte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__